<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ $t('SettingBaseDataLov.table.basicInformation') }}</BjDivider>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataLov.table.name')" prop="meaning">
        <BjInput
          v-model="form.meaning"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataLov.table.code')" prop="value">
        <BjInput v-model="form.value" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('SettingBaseDataLov.table.sort')" prop="orderSeq">
        <BjInputNumber v-model="form.orderSeq" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { baseDataApi } from '@/api';

const getDefaultForm = () => {
  return {
    _innerMap: {},
    description: null,
    enabledFlag: 1,
    endDateActive: null,
    lovCode: null,
    lovId: null,
    lovValueId: null,
    meaning: null,
    orderSeq: null,
    parentMeaning: null,
    parentValue: null,
    startDateActive: null,
    tag: null,
    tenantId: null,
    tenantName: null,
    value: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        meaning: [{ required: true, message: this.$t('SettingBaseDataLov.table.nameText'), trigger: 'blur' }],
        value: [{ required: true, message: this.$t('SettingBaseDataLov.table.codeText'), trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!(info && info.meaning);
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('SettingBaseDataLov.table.edit') : this.$t('SettingBaseDataLov.table.add'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },

    addApi(API_DATA) {
      baseDataApi.addLovValues(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      baseDataApi.updateLovValues(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
